import styled, { css } from 'styled-components';
import { device } from '../../../styles/devices';
import { COLORS, SIZING } from '../../../styles/variables';

export const PricesContainer = styled.div`
  padding-bottom: ${SIZING.unit(3)};
  padding-right: ${SIZING.unit(1.5)};
  padding-left: ${SIZING.unit(1.5)};
  @media ${device.tablet} {
    padding-right: ${SIZING.unit(2)};
    padding-left: ${SIZING.unit(2)};
  }
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
`;

export const PriceRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 16px;
  width: 100%;
  justify-content: space-between;
`;

export const Label = styled.div<{ color?: string }>`
  color: ${({ color }) => color || COLORS.grey80};
  font-family: 'Audi Type';
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.002px;
`;

export const AmountContainer = styled.button<{ alignCenter?: boolean; isSelectable?: boolean }>`
  padding: 0;
  margin: 0;
  border: none;
  background-color: transparent;
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  gap: 4px;
  color: ${COLORS.grey80};
  cursor: ${({ isSelectable }) => isSelectable && 'pointer'};
  align-self: ${({ alignCenter }) => alignCenter && 'center'};
`;

export const Amount = styled.div<{ largeFont?: boolean }>`
  color: ${COLORS.grey80};
  font-family: 'Audi Type';
  font-size: ${(props) => (props.largeFont ? '16px' : '12px')};
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.002px;
  width: max-content;
`;

export const InfoIconContainer = styled.div`
  width: 16px;
  height: 16px;
`;

export const Total = styled.div`
  color: ${COLORS.grey80};
  font-family: 'Audi Type';
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0.002px;
`;

export const TotalWrapper = styled.div`
  padding-top: 4px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
`;

export const SinglePriceContainer = styled.div`
  padding: ${SIZING.unit(2)} ${SIZING.unit(0)};
  padding-top: ${SIZING.unit(1)};
  @media ${device.tablet} {
    padding: ${SIZING.unit(2)} ${SIZING.unit(1)};
    padding-top: ${SIZING.unit(1)};
  }
`;

export const DualPriceContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 16px;
  padding: ${SIZING.unit(2)} ${SIZING.unit(0)};
  padding-top: ${SIZING.unit(1)};
  @media ${device.tablet} {
    padding: ${SIZING.unit(2)} ${SIZING.unit(1)};
    padding-top: ${SIZING.unit(1)};
  }
`;

export const PriceWrapper = styled.div`
  display: flex;
  gap: 8px;
  align-items: flex-end;
  margin-bottom: 4px;
`;
